import React from 'react'
import * as styled from './styled'

const Button = ({ children, primary, ...props }) => {
    return (
        <styled.Button primary={primary} {...props}>{children}</styled.Button>
    )
}

export default Button
